(function ($) {
	RVwys.plugin['SelectStyle'] = {};
	RVwys.aStyleData = {}; 
	 $(document).bind('editorReady',function() {
		 
		 $('.SelectStyle').ready(function(){
			 RVwys.LoadsCustomStyle();
		 });

		 $('.setStyle').click(function() {
			 RVwys.addEventSetStyle($(this));
		 });
	 });
		RVwys.addCustomStyle = function(key, data){
			newLI = $('<li>'
					 +'<a href="javascript:void(0)" class="setStyle" key="' + key + '" cmd="formatBlock" set="div">'
					 +'<span></span></a>'
					 +'<a href="javascript:void(0)"class="deleteStyle" key="' + key + '" style="float:right;">Delete</a>'
					 +'</li>'); 
			 newLI.find('.deleteStyle').click(function() {
				 var key = $(this).attr('key');
				 $(this).parent().remove();
				 delete RVwys.aStyleData[key];
				 localStorage['saveStyle'] = JSON.stringify(RVwys.aStyleData, null, 2);
				 setTimeout(function(){$(".SelectStyle dt a").trigger('click');},10);
			 }).end().find('.setStyle').click(function(){
				 RVwys.addEventSetStyle($(this));
			 });
			 newLI.find('span').append(data);
			 $(".SelectStyle dd ul").append(newLI);
		};
		RVwys.LoadsCustomStyle = function() {
			if(!localStorage['saveStyle'] || localStorage['saveStyle'] == '') {
				return false;
			}
			 this.aStyleData = jQuery.parseJSON(localStorage['saveStyle']);
			$.each(this.aStyleData, function(k,v){
				RVwys.addCustomStyle(k, v);
			});
		};
		RVwys.addEventSetStyle = function(obj){
			 var cmd = obj.attr('cmd');
			 var set = obj.attr('set');
			 range = RVwys.getRange();
			 var tagParent = RVwys.getRangeParent();
			 var isRangeText = RVwys.isRangeText(range);
			 if (isRangeText) {
				 var key = obj.attr('key');
				 RVwys.aStyleData[key];
				 var data = RVwys.aStyleData[key];
				 data = data.replace('CUSTOM STYLE', isRangeText);
				 RVwys.insertHTML($(data));	 
			 }
		};
})(jQuery);